<template lang="pug">
page(
    main-title="Тарифный план и оплата",
    main-description="Выберите способ оплаты и подходящий тарифный план",
    :links="[{component: 'TariffPlan', title: 'Тарифный план и оплата'}, 'Оплатить']"
)
    .row 
        .col-md-12(style="line-height: 23px")
            span Способ оплаты:
    .row
        .col-md-12
            .radio.clip-radio.radio-primary
                input#payment_method_card(type="radio", 
                                          v-model="paymentMethod", 
                                          value="card")
                label(for="payment_method_card") Банковской картой
            .radio.clip-radio.radio-primary
                input#payment_method_cashless(type="radio", 
                                              v-model="paymentMethod", 
                                              value="cashless")
                label(for="payment_method_cashless") Безналичный расчет
    .row
        .col-md-12(v-if="empty_company_req && paymentMethod == 'cashless'")
            p 
                b Внимание! Для выставления счёта 
                router-link(:to="{name: 'UserInfo'}") заполните реквизиты компании

    .row.margin-top-10(v-if="paymentMethod == 'card' || !empty_company_req")
        .col-md-6(v-for="item in tariffs")
            .panel.panel-white.text-center
                .panel-body 
                    h3 {{ item.name }}
                    p Стоимость тарифа: 
                        span.text-bold {{ item.endCost }} руб.
                        span(v-if="item.tariff.discount")  (скидка 
                            span.text-bold {{ item.tariff.discount.value }} руб.
                            | )
                    a(:href='initPaymentUrl(item.frequency)').btn.btn-default Выбрать

</template>

<script>
export default {
    name: 'Payment',
    created() {
        this.$store.dispatch('getTariffPlanState');
    },
    methods: {
        selectPlan() {
            this.$store.dispatch('initPayment', {
                paymentMethod: this.paymentMethod
            });
        },
        initPaymentUrl(frequency) {
            return `${process.env.DJANGO_HOST}/payments/init/?payment_method=${this.paymentMethod}&payment_frequency=${frequency}`;
        },
        editCompanyData() {
            this.$router.push({name: 'UserInfo'});
        }
    },
    computed: {
        prices() {
            return this.$store.state.payments.pricesAndDiscounts;
        },
        tariffs() {
            if (!this.prices.monthly && !this.prices.annually) {
                return [];
            }
            let items = [{name: 'Месяц', tariff: this.prices.monthly, frequency: 'monthly'},
                         {name: 'Год', tariff: this.prices.annually, frequency: 'annually'}];
            for (let item of items) {
                item.endCost = item.tariff.amount;
                if (item.tariff.discount) {
                    item.endCost -= item.tariff.discount.value;
                }
            }
            return items;
        },
        empty_company_req() {
            let profile = {...this.$store.state.users.profile};
            return (!profile.legal_entity || !profile.legal_address || !profile.legal_inn);
        }
    },
    data() {
        return {
            paymentMethod: 'card'
        };
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/payments/Payment.vue